import moment from "moment";
import React from "react";

export function buildGantt(value, count) {
    const lastMonthStart = value.clone().startOf("month").startOf("week");
    const nextMonthEnd = value.clone().endOf("month");
    const day = lastMonthStart.clone().subtract(1, "day");
    const months = [];
    const datee = value.clone()
    let counter = 1;
    const daysNumber = moment().daysInMonth();

    while (day.isBefore(nextMonthEnd, "day")) {
        let weekObj = {
            weekTitle: "",
            weekDays: [],
            monthDays: [],
            yearTitle: "",
            dayTitle: "",
            monthTitle: "",
        };
        // if (View == "Week/Day"){
        while (counter <= count) {
            weekObj.weekDays.push(day.add(1, 'day').clone());
            if (counter == 1) {
                weekObj.weekTitle += day.format('DD MMMM').split(',')[0] + ' - ';


            }
            if (counter == count) {
                weekObj.weekTitle += day.format('DD MMMM').split(',')[0];
                months.push(weekObj)
            }

            counter = counter + 1;
            // }
        }

        
        counter = 1;
        
        for (let i = 0; i < daysNumber; i++) {
            weekObj.monthDays.push(moment().add(1, 'day').clone());
        }
        weekObj.yearTitle = datee.format('YYYY').split(',')[0];
        weekObj.dayTitle = datee.format('DD MMM MM YYYY').split(',')[0];
        weekObj.monthTitle = datee.format('MMMM YYYY').split(',')[0];

    }
    return months;




}
